import { ProductTour } from "src/components/tour/tour.type";
import { find } from "lodash";
import { isChromiumBased } from "./helper";
const handleTourClose = (moduleId) => {
  const viewedTours = getViewedTours() || [];
  if (!viewedTours.includes(moduleId)) {
    viewedTours.push(moduleId);
    window.localStorage && window.localStorage.setItem("viewed_tours", JSON.stringify(viewedTours));
  }
}

const getViewedTours = () => {
  return JSON.parse(window.localStorage && window.localStorage.getItem("viewed_tours") || "[]");
}

const canShowTour = (moduleId, tours: ProductTour[]) => {
  const activeTour = find(tours, (tour) => tour.moduleIds.includes(moduleId));
  const viewedTours = getViewedTours();
  return activeTour && !viewedTours.includes(moduleId) && validateTour(activeTour);
}

const validateTour = (tour: ProductTour) => {
  if (!tour) return false;

  switch (tour.tourId) {
    case "chrome_extension": {
      return isChromiumBased() ? true : false
    }
    default:
      return true;
  }
}

export {
  handleTourClose,
  canShowTour
}